import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;
const putUnreadCount = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.MY_QUERIES.PUT_UNREAD_COUNT,
    "",
    cancelToken
  );
};

export default putUnreadCount;
